import React from 'react';

class SecureComponent extends React.Component {
    constructor(props) {
        super(props);
        let authorized = false;
        if (props.authorizationLevel && props.authorizationLevel != 0) {
            authorized = (props.userAutorizationLevel & props.authorizationLevel) !== 0;
        }
        else {
            authorized = true;
        }
        this.state = { authorized };
    }
}

export default SecureComponent;